// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'expose-loader?$!expose-loader?jQuery!jquery'
//import 'fullpage.js/vendors/scrolloverflow.min.js'
import 'normalize.css/normalize.css'

import 'fullpage.js/dist/jquery.fullpage.min.js'
import 'fullpage.js/dist/jquery.fullpage.extensions.min.js'
import 'fullpage.js/dist/jquery.fullpage.min.css'

import './lib/slick.min.js';
import './lib/slick.css';

Vue.config.productionTip = false

//QUERY
var search = decodeURIComponent(window.location.search.replace("?","")).split("&");
window.query = {};
for (var i=0; i<search.length; i++) {
	window.query[search[i].split('=')[0]] = search[i].split('=')[1] || null;
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App }
});


// WEBPACK FOOTER //
// ./src/main.js